<template>
  <div id="app" class="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
    }
  },
  watch: {
    $route (newVal) {
      // if (
      //   this.$route.path !== '/login' &&
      //   this.$route.path !== '/register' &&
      //   this.$route.path !== '/forget-pwd' &&
      //   this.$route.path !== '/error'
      // ) {
      //   const token = localStorage.getItem('token')
      //   if (!token) {
      //     this.$router.push('/login')
      //     return this.$utils.MessageText('请先登录后再进行操作')
      //   }
      // }
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
.app{
  min-height: 100%;
  position: relative;
}
*{
  margin: 0;
  padding: 0;
  list-style: none;
}
html{
  font-size: 16px;
  color: #333;
  min-width: 75rem;
}
button{
  outline: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
}
input{
  background: none;
  border: none;
  width: 100%;
  box-sizing: border-box;
  font-size: 16px;
}
img{
  margin: 0;
  padding: 0;
  font-size: 0;
}
</style>
